const PREFIX = '@HEALTH/';

const PAY_PRO = `${PREFIX}PAY_PRO`;
const PAY_PRO_STATUS = `${PAY_PRO}:STATUS`;
export const PAY_PRO_STATUS_GET = `${PAY_PRO_STATUS}:GET`;
export const PAY_PRO_STATUS_SET = `${PAY_PRO_STATUS}:SET`;
